import type React from 'react';

import * as styles from './styles';
import { ActionButtonType } from '..';
import type { ButtonBaseProps } from '@material-ui/core/ButtonBase';

/* eslint-disable-next-line import/no-cycle */
import { Button } from '@cobliteam/ui/components';

import EditRoundedIcon from '@mui/icons-material/EditRounded';

interface ActionButtonProps extends ButtonBaseProps {
  actionButtonName?: string;
  ActionIcon?: any;
  actionButtonType?: ActionButtonType;
  hideButton?: boolean;
  isAlwaysVisible?: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const ActionButton: React.FC<ActionButtonProps> = ({
  actionButtonName = 'Editar',
  actionButtonType = ActionButtonType.DEFAULT,
  onClick,
  ActionIcon,
  disabled = false,
  hideButton = false,
  isAlwaysVisible = false,
}) => {
  const getIcon = () => {
    if (actionButtonName === 'Editar') return <EditRoundedIcon />;
    if (ActionIcon) return <ActionIcon />;

    return null;
  };

  return (
    <div className={styles.buttonContainer(hideButton, isAlwaysVisible)}>
      <Button variant='text' color={actionButtonType === ActionButtonType.DEFAULT ? 'primary' : 'danger'} disabled={disabled} startIcon={getIcon()} onClick={onClick}>
        {actionButtonName}
      </Button>
    </div>
  );
};

export default ActionButton;
